import { render, staticRenderFns } from "./NovelListItem.vue?vue&type=template&id=07f50720&scoped=true"
import script from "./NovelListItem.vue?vue&type=script&lang=ts"
export * from "./NovelListItem.vue?vue&type=script&lang=ts"
import style0 from "./NovelListItem.vue?vue&type=style&index=0&id=07f50720&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f50720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f50720')) {
      api.createRecord('07f50720', component.options)
    } else {
      api.reload('07f50720', component.options)
    }
    module.hot.accept("./NovelListItem.vue?vue&type=template&id=07f50720&scoped=true", function () {
      api.rerender('07f50720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/NovelListItem.vue"
export default component.exports